module.exports = __webpack_public_path__ + "static/portico_03-0b4206595e7edd13bd7b16f07b68341f.jpg";